import { Box, Typography } from "@mui/material";

const Footer = () => {
  const buildVersion = import.meta.env.VITE_APP_BUILD_VERSION;
  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        py: 1,
        px: 1,
        textAlign: "center",
        backgroundColor: "#f5f5f5",
        mt: "auto",
      }}
    >
      <Typography variant="body2" color="textSecondary">
       EgonZehnder © {new Date().getFullYear()} Fusion Platform. All rights reserved.
       {buildVersion && ` | v${buildVersion}`}
      </Typography>
    </Box>
  );
};

export default Footer;
